import { render, staticRenderFns } from "./TopInfo.vue?vue&type=template&id=391c473a&scoped=true&"
import script from "./TopInfo.vue?vue&type=script&lang=js&"
export * from "./TopInfo.vue?vue&type=script&lang=js&"
import style0 from "./TopInfo.vue?vue&type=style&index=0&id=391c473a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c473a",
  null
  
)

export default component.exports